"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiCallHelper = void 0;
class ApiCallHelper {
    static async loadBotTest() {
        var _a, _b;
        if (!this.botTestId)
            return;
        this.loading = true;
        try {
            const response = await this.apiService.back.get('bot-test.get', {
                routeParams: { id: String(this.botTestId) }
            });
            if (response.success && response.data) {
                this.botTest = response.data;
                // Set the first tester as active tester tab by default
                if (this.botTest.testers && this.botTest.testers.length > 0) {
                    this.activeTesterTab = String(this.botTest.testers[0].id) || '';
                }
            }
            else {
                (_a = this.notifyService) === null || _a === void 0 ? void 0 : _a.notify(response.error || 'botTest.preview.error.load_failed'.t(), 'error');
            }
        }
        catch (e) {
            console.error('Error loading bot test:', e);
            (_b = this.notifyService) === null || _b === void 0 ? void 0 : _b.notify('botTest.preview.error.load_failed'.t(), 'error');
        }
        finally {
            this.loading = false;
        }
    }
    static async runTest(testers) {
        var _a;
        if (!this.testers || this.testers.length === 0)
            return;
        try {
            for (const tester of testers) {
                const response = await this.apiService.back.get('bot-test.run', {
                    routeParams: { id: String(tester.id) }
                });
                if (response.success) {
                    this.startedTester(tester);
                }
            }
            setTimeout(() => {
                this.$emit('close-test-window');
            }, 4000);
        }
        catch (error) {
            console.error('Error running bot test:', error);
            (_a = this.notifyService) === null || _a === void 0 ? void 0 : _a.notify('botTest.preview.run_failed'.t(), 'error');
        }
        finally {
        }
    }
}
exports.ApiCallHelper = ApiCallHelper;
